var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-5",staticStyle:{"text-align":"center"}},[(_vm.error)?_c('div',[_vm._v("エラーが発生しました。")]):_c('vue-simple-spinner',{attrs:{"message":"Redirect..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }